<template>
  <div class="container college">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>机构</el-breadcrumb-item>
        <el-breadcrumb-item>核销管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="page-title">核销管理</h2>
        </div>
        <div class="right">
          <el-button class="button"
                     type="primary"
                     @click="writeoffGiftDialog = true">核销赠送</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="商品名称"
                      prop="name">
          <el-input v-model="query.product_keyword"
                    placeholder="输入商品名称"
                    @input="productCodeList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="商品类型"
                      prop="ref_type">
          <el-select v-model="query.product_types"
                     multiple
                     collapse-tags
                     clearable
                     placeholder="请选择"
                     style="width: 150px"
                     @change="productCodeList(true)">
            <el-option v-for="item in filter.refTypes"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="加盟商信息"
                      prop="goods_name">
          <el-input v-model.trim="query.warrant_user_keyword"
                    placeholder="输入加盟商信息"
                    @input="productCodeList()"
                    clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="values-header"
           style="display:flex;justify-content: space-between;">
        <p class="title">核销列表</p>
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           label="ID"
                           min-width="50"
                           align="center">
          </el-table-column>
          <el-table-column prop="code_product_name"
                           label="商品名称"
                           min-width="150"
                           align="center">
          </el-table-column>
          <el-table-column prop="goods_name"
                           label="商品类型"
                           width="80"
                           align="center">
            <template slot-scope="scope">
              <span>{{ formatRef_type(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="加盟商信息"
                           width="200"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{
               `${scope.row.warrant_user_company_name}/${scope.row.warrant_user_alias}/${scope.row.warrant_user_phone}`
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="code_count_total"
                           label="核销进度"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              {{scope.row.code_count_exchange_finish}}/{{scope.row.code_count_total}}
            </template>
          </el-table-column>

          <el-table-column label="创建时间"
                           min-width="90"
                           align="center">
            <template slot-scope="scope">
              <span>{{$moment(scope.row.create_time).format('YYYY-MM-DD HH:mm')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="180"
                           align="center"
                           fixed="right">
            <template slot-scope="scope">
              <el-link :underline="false"
                       type="primary"
                       style="marginRight:5px"
                       @click="download(scope.row)">下载</el-link> | <el-link :underline="false"
                       type="primary"
                       style="marginLeft:5px"
                       @click="handleContion(scope.row)">核销明细</el-link>

            </template>
          </el-table-column>

        </el-table>

      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>

    <serviceCondition :visible="conditonDialog"
                      :editRow="editRow"
                      @close="handleLookClose"
                      @sumbit="productCodeList()"></serviceCondition>
    <WriteoffGift :visible="writeoffGiftDialog"
                  @close="writeoffGiftDialog = false"
                  @submit="handleWriteoffGiftSubmit"></WriteoffGift>
  </div>
</template>

<script>
import { taskList } from '@/api/warrant'
import {
  taskExport,
} from '@/api/productExchange'
import serviceCondition from '@/components/dialog/productCode/serviceCondition'
import WriteoffGift from '@/components/dialog/warrant/WriteoffGift'
export default {
  components: { serviceCondition, WriteoffGift },
  data() {
    return {
      conditonDialog: false,
      writeoffGiftDialog: false,
      editRow: {},
      query: {
        handle_task_types: 2, //任务类型 1 普通任务  2加盟商任务
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        product_types: '',
      },
      pageTotal: 10,
      results: [],
      filter: {
        refTypes: [
          { label: '课程', value: '1' },
          { label: '题库', value: '2' },
          { label: '专栏', value: '3' },
          { label: '资料', value: '4' },
        ],
      },
    }
  },
  created() {
    this.productCodeList()
  },
  methods: {
    formatRef_type(row) {
      const obj = {
        0: '无',
        1: '课程',
        2: '题库',
        3: '专栏',
        4: '资料',
        5: '文章',
        6: '学长',
        7: '联报',
      }
      return obj[row.code_product_type] || ''
    },
    download(row) {
      taskExport({ start_code_task_id: row.id }).then((res) => {
        if (res) {
          this.$message.success(`导出成功`)
          window.open(res.url)
        }
      })
    },
    handleContion(row) {
      this.editRow = row
      this.conditonDialog = true
    },
    // 消息列表请求
    productCodeList() {
      const params = Object.assign({}, this.query)

      if (params.product_types) {
        params.product_types = params.product_types.filter((v) => v).join(',')
      }
      taskList(params).then((res) => {
        this.results = res.list || []

        this.pageTotal = res.count
      })
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.productCodeList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.productCodeList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.productCodeList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.productCodeList()
    },

    handleLookClose() {
      this.conditonDialog = false
    },
    handleWriteoffGiftSubmit() {
      this.writeoffGiftDialog = false
      this.$set(this.query, 'pageIndex', 1)
      this.productCodeList()
    },
  },
}
</script>

<style scoped lang="less">
.buttonRecord {
  cursor: pointer;
  width: 100px;
  border-radius: 2px;
  height: 32px;
  font-size: 13px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  background: #409eff;
}
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .content {
      display: flex;
      align-items: center;
    }
    .left,
    .right {
      flex: 1;
    }
    .page-title {
      margin: 0;
      font-size: 30px;
      font-weight: 500;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;

      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
